export const STREAMLAIN_APP_TOPBAR_HEIGHT = 52;

/** The app's AI island: its size and its least gap to the view's bottom and side edges. */
export const STREAMLAIN_AI_ISLAND_SIZE = 52;
export const STREAMLAIN_AI_ISLAND_INSET = 16;

/** The points the user can drag the AI island to. */
export const STREAMLAIN_AI_ISLAND_SNAP_POINTS = [
  'bottom-left',
  'bottom-center',
  'bottom-right',
] as const;
export type StreamlainAIIslandSnapPoint =
  (typeof STREAMLAIN_AI_ISLAND_SNAP_POINTS)[number];
export const STREAMLAIN_AI_ISLAND_DEFAULT_SNAP_POINT: StreamlainAIIslandSnapPoint =
  'bottom-center';

/**
 * Body property for the view's floating controls (e.g. the media pill): the island's footprint in the
 * view's bottom-right corner; 0px while it shows elsewhere or hides.
 */
export const AI_ISLAND_AVOID_INLINE_END_PROPERTY =
  '--streamlain-ai-island-avoid-inline-end';
